import { Line } from "vue-chartjs";
import { ChartConfig } from "@/config/chart.js";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import "chartjs-adapter-moment";

export default {
  extends: Line,
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    },
    colors: {
      type: Array
    }
  },
  data() {
    return {
      gradient: null,
      chartOptions: {
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              tooltipItem.yLabel > 20
                ? (tooltipItem.yLabel = "> 20")
                : tooltipItem.yLabel;

              return `${data.datasets[tooltipItem.datasetIndex].label}: ${
                tooltipItem.yLabel
              }`;
            }
          }
        },
        layout: {
          padding: {
            top: 10
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: false,
        scales: {
          xAxes: [
            {
              ticks: {
                display: true,
                fontSize: ChartConfig.fontSize,
                padding: ChartConfig.padding,
                fontFamily: ChartConfig.fontFamily,
                fontColor: ChartConfig.fontColor
              },
              type: "time",
              time: {
                minUnit: "day",
                displayFormats: {
                  minute: "DD MMM YY",
                  hour: "DD MMM YY",
                  day: "DD MMM YY",
                  week: "DD MMM YY",
                  month: "DD MMM YY"
                }
              },
              display: true,
              gridLines: {
                drawOnChartArea: false
              }
            }
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: this.$t("message.common.yourPositionOnGoogleMaps"),
                fontSize: 16,
                padding: {
                  bottom: 10
                }
              },
              ticks: {
                fontSize: ChartConfig.fontSize,
                padding: ChartConfig.padding,
                fontFamily: ChartConfig.fontFamily,
                fontColor: ChartConfig.fontColor,
                min: 1,
                max: 21,
                beginAtZero: false,
                reverse: true,
                callback: function(value, index, values) {
                  values.some(val =>
                    val > 20 ? (values[values.length - 1] = 21) : false
                  );

                  if (value > 20) {
                    return "> 20";
                  }
                  return value;
                }
              }
            }
          ]
        }
      }
    };
  },
  beforeCreate() {
    Chart.plugins.unregister(ChartDataLabels);
  },
  mounted() {
    this.$emit("loadingChartStatus", true);
    this.render();
  },
  watch: {
    labels: function() {
      this.render();
      this.$emit("loadingChartStatus", false);
    },
    data: function() {
      this.render();
      this.$emit("loadingChartStatus", false);
    }
  },
  methods: {
    formatData(data) {
      return data.map(value => (value > 20 ? (value = 21) : value));
    },

    createDataSet(data) {
      const dataset = data.map(item => {
        return {
          label: `${item.name}, ${item.address}`,
          borderColor: item.color,
          pointBorderColor: item.color,
          pointBackgroundColor: item.color,
          pointHoverBackgroundColor: item.color,
          pointHoverBorderColor: item.color,
          footer: item.address,
          pointBorderWidth: 3,
          pointHoverRadius: 3,
          pointHoverBorderWidth: 3,
          pointRadius: 3,
          fill: false,
          clip: 3,
          backgroundColor: "transparent",
          borderWidth: 3,
          data: this.formatData(item.data)
        };
      });

      return dataset;
    },

    render() {
      this.renderChart(
        {
          labels: this.labels,
          datasets: this.createDataSet(this.data)
        },
        this.chartOptions
      );
    }
  }
};
